// START IMPORTS
// Context imports
import { createRequestConfig } from '@ltvco/refresh-lib/ctx';
// END IMPORTS

// START CONSTANTS
const appRequests = createRequestConfig();

// Here you can make changes to any of the default app requests coming from refresh lib
// appRequests = {
// ...appRequests,
// somethingIWantToChange: {
//   ...appRequests.somethingIWantToChange,
// fetchSomething: () => {new function here}
// }
// },
// END CONSTANTS

export { appRequests };
